/* Stressless Store — toont in de winkelwagen de foto die de klant in de configurator samenstelde.
   De configurator geeft de renderfoto mee als verborgen besteleigenschap `_foto`
   en `_crop` = left|right (51 %) of left:0.63|right:0.63 (eigen breedte) wanneer de voetenbank uit beeld moet.
   Valt stil terug op de gewone variantfoto als er geen `_foto` is. */
(function () {
  var ROWSEL = '.cart-item';
  var BOXSEL = '.cart-item__image, img';

  function lists() {
    var c = document.querySelectorAll('cart-items, cart-drawer-items, #main-cart-items');
    return c.length ? c : [document];
  }

  function parseCrop(v) {
    if (!v) return null;
    var p = String(v).split(':');
    var k = parseFloat(p[1]);
    return { s: p[0] === 'right' ? 'right' : 'left', k: (k > 0 && k < 1) ? k : 0.51 };
  }

  function paint(row, it) {
    var url = it && it.properties && it.properties._foto;
    if (!url) return false;
    if (row.getAttribute('data-cfgfoto') === url) return false;
    var img = row.querySelector(BOXSEL);
    if (!img) return false;
    var box = img.parentElement;
    if (!box) return false;

    row.setAttribute('data-cfgfoto', url);
    var crop = parseCrop(it.properties._crop);
    var old = box.querySelector('.cfg-foto');
    if (old) old.parentNode.removeChild(old);
    if (getComputedStyle(box).position === 'static') box.style.position = 'relative';
    img.style.visibility = 'hidden';

    var wrap = document.createElement('span');
    wrap.className = 'cfg-foto';
    wrap.style.cssText = 'position:absolute;top:0;height:100%;overflow:hidden;background:#fff;' +
      (crop ? 'left:' + ((1 - crop.k) * 50) + '%;width:' + (crop.k * 100) + '%;' : 'left:0;width:100%;');

    var im = document.createElement('img');
    im.alt = '';
    im.loading = 'lazy';
    im.src = url;
    im.style.cssText = 'display:block;height:100%;max-width:none;object-fit:contain;width:' +
      (crop ? (100 / crop.k) + '%' : '100%') + ';' + (crop && crop.s === 'right' ? 'margin-left:-' + (100 / crop.k - 100) + '%;' : '');

    wrap.appendChild(im);
    box.appendChild(wrap);
    return true;
  }

  function apply(items) {
    lists().forEach(function (list) {
      var rows = list.querySelectorAll(ROWSEL);
      for (var i = 0; i < rows.length; i++) paint(rows[i], items[i]);
    });
  }

  var busy = false;
  function run() {
    if (busy) return;
    if (!document.querySelector(ROWSEL)) return;
    busy = true;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { if (c && c.items) apply(c.items); })
      .catch(function () { })
      .then(function () { busy = false; });
  }

  function todo() {
    return !!document.querySelector(ROWSEL + ':not([data-cfgfoto])');
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();

  var t = null;
  new MutationObserver(function () {
    if (!todo()) return;
    clearTimeout(t);
    t = setTimeout(run, 150);
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
